import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import walletService from '../../../services/walletService';
import './WalletBalance.css';

const WalletBalance = () => {
  const [balance, setBalance] = useState(0);
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBalance();
    
    // Refresh balance every 30 seconds
    const interval = setInterval(fetchBalance, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchBalance = async () => {
    try {
      const response = await walletService.getSummary();
      if (response.data?.success) {
        setBalance(response.data.data?.balance || 0);
        setIsPremium(response.data.data?.is_premium || false);
      }
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
    } finally {
      setLoading(false);
    }
  };

  // Safe number formatter
  const formatNumber = (num) => {
    if (num === undefined || num === null) return '0';
    return num.toLocaleString();
  };

  if (loading) {
    return <div className="wallet-balance loading">...</div>;
  }

  return (
    <Link to="/wallet" className="wallet-balance">
      <div className="balance-icon">💎</div>


      <div className="balance-info">
        <span className="balance-amount">{formatNumber(balance)}</span>
        <span className="balance-label">Diamants</span>

        {isPremium && <span className="premium-badge">⭐</span>}
      </div>
    </Link>
  );
};

export default WalletBalance;
